<template>
  <Layout>
    <manufacture-edit-modal
        id="manufacture-edit-modal"
        :key="`manufacture-edit-modal`"
        ref="manufacture_edit_modal"
        :modal-title="lodash.upperCase(`${$t('edit')} ${$t('manufactures.singular')}`)"
        @updated="fetchModel"
    ></manufacture-edit-modal>
    <Loader :loading="loading || updating" no-axios>
      <div v-if="(model || {}).id">
        <a @click="$router.back()">
          <div class="container-title d-flex align-items-center">
            <span class="me-2">
              <svg
                  fill="none"
                  height="16"
                  viewBox="0 0 16 16"
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M6.875 15.3001L0.275 8.70008C0.175 8.60008 0.104 8.49175 0.0619998 8.37508C0.0206665 8.25842 0 8.13342 0 8.00008C0 7.86675 0.0206665 7.74175 0.0619998 7.62508C0.104 7.50842 0.175 7.40008 0.275 7.30008L6.875 0.700082C7.05833 0.516749 7.28733 0.420749 7.562 0.412083C7.83733 0.404083 8.075 0.500082 8.275 0.700082C8.475 0.883416 8.57933 1.11242 8.588 1.38708C8.596 1.66242 8.5 1.90008 8.3 2.10008L3.4 7.00008H14.575C14.8583 7.00008 15.096 7.09575 15.288 7.28708C15.4793 7.47908 15.575 7.71675 15.575 8.00008C15.575 8.28342 15.4793 8.52075 15.288 8.71208C15.096 8.90408 14.8583 9.00008 14.575 9.00008H3.4L8.3 13.9001C8.48333 14.0834 8.57933 14.3167 8.588 14.6001C8.596 14.8834 8.5 15.1167 8.3 15.3001C8.11667 15.5001 7.88333 15.6001 7.6 15.6001C7.31667 15.6001 7.075 15.5001 6.875 15.3001Z"
                    fill="#6C7589"
                />
              </svg>
            </span>
            {{ $t("manufactures.singular") }}
          </div>
        </a>
        <b-card>
          <div class="d-flex justify-content-between">
            <div class="text-primary section-label">{{ lodash.upperCase($t('manufactures.type')) }}</div>
            <div v-if="!denyEdit">
              <b-button variant="primary" @click="$refs.manufacture_edit_modal.edit(model.id)">Edit</b-button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="row col-md-12">
                <div class="col-md-6 label">
                  {{ lodash.upperFirst($t('manufactures.name')) }}
                </div>
                <div class="col-md-6 value">
                  {{ model.name }}
                </div>
              </div>
              <div class="row col-md-12">
              <div class="col-md-6 label">
                {{ lodash.upperFirst($t('manufactures.short_name')) }}
              </div>
              <div class="col-md-6 value">
                {{ model.short_name ? model.short_name : '-' }}
              </div>
            </div>
              <div class="row col-md-12">
                <div class="col-md-6 label">
                  {{ lodash.upperFirst($t('manufactures.type')) }}
                </div>
                <div class="col-md-6 value">
                  {{ lodash.upperFirst(typeTranslation) }}
                </div>
              </div>
              <div class="row col-md-12">
                <div class="col-md-6 label">
                  {{ lodash.upperFirst($t('manufactures.status')) }}
                </div>
                <div class="col-md-6 value">
                  {{ lodash.upperFirst(model.is_active ? $t('manufactures.active') : $t('manufactures.inactive')) }}
                </div>
              </div>
              <div class="row col-md-12 mb-3">
                <div class="col-md-6 label-auditable fw-bold font-size-10">
                  {{ lodash.startCase(this.$t(`CreatedAt`)) }}
                </div>
                <div class="col-md-6 label-auditable font-size-10">
                  : {{ createdAt }}
                </div>
              </div>
              <div class="row col-md-12 mb-3">
                <div class="col-md-6 label-auditable fw-bold font-size-10">
                  {{ lodash.startCase(this.$t(`UpdatedBy`)) }}
                </div>
                <div class="col-md-6 label-auditable font-size-10">
                  : {{ updaterName }}
                </div>
              </div>
              <div class="row col-md-12 mb-3">
                <div class="col-md-6 label-auditable fw-bold font-size-10">
                  {{ lodash.startCase(this.$t(`UpdatedAt`)) }}
                </div>
                <div class="col-md-6 label-auditable font-size-10">
                  : {{ updatedAt }}
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </Loader>
  </Layout>
</template>

<script>
import ModelShow from "../models/show";
import Row from "@/components/models/show/custom-row";
import Loader from "@/components/widgets/loader";
import Swal from "sweetalert2";
import ManufactureEditModal from '@/components/modals/manufacture-edit.vue'

export default {
  extends: ModelShow,
  page: {
    title: "Detail Manufactures",
  },
  components: {
    Loader,
    ManufactureEditModal,
  },
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t("manufactures.singular"));
      },
    },
    resourceRoute: {default: "manufactures"},
    modelVariable: {default: "manufacture"},
    denyEdit: {
      type: Boolean,
      default() {
        return !this.$auth.hasPermissionTo("hatcheries.edit");
      },
    },
    denyDelete: {type: Boolean, default: true},
    columns: {
      type: Object,
      default() {
        return {
          [this.modelVariable || "model"]: [
            {
              key: "key",
              label: this.$t("models.key"),
              component: Row,
            },
          ],
        };
      },
    },
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t("manufactures.plural")),
      segmentedButtons: [],
      updating: false,
      // segmentedButtons(){
      //   return this.model.type.map((manufacture_type) => ({ text: this.$t(`manufactures.types.${manufacture_type}`), value: manufacture_type }))
      // }
    };
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    typeTranslation() {
      return this.$t(`manufactures.types.${this.model.type}`)
    },
    createdAt() {
      return this.$moment.utc(this.model.created_at).local().format('lll')
    },
    updatedAt() {
      return this.$moment.utc(this.model.updated_at).local().format('lll')
    },
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t("manufactures.plural")),
          href: "/manufactures",
        },
        {
          text:
              this.model && this.model.id
                  ? this.model["name"]
                  : this.$route.params.key,
          href: `/manufactures/${this.$route.params.key}`,
          active: true,
        },
      ];
    },
    creatorName() {
      let name = this.model.creator?.name
      if (!name) return '-'
      return name
    },
    updaterName() {
      let name = this.model.updater?.name
      if (!name) return '-'
      return name
    },
  },
  methods: {
    delete() {
      return this.$axios.delete(`/manufactures/${this.$route.params.key}`);
    },
    fetchModel() {
      this.loading = true;
      return this.$axios
          .get(`/v1/manufactures/${this.$route.params.key}`, {
            params: {
              with: [
                "creator",
                "updater",
              ].join(','),
            },
          })
          .then((response) => {
            const {
              data: {data},
            } = response;
            this.$set(this, 'model', data)
            this.$set(this, 'denyEdit', 
              data.source?.name === 'jala' || !this.$auth.hasPermissionTo("hatcheries.edit")
            )

            return response;
          })
          .catch((error) => this.failedAlert(error))
          .finally(() => (this.loading = false));
    },
    onStatusChange(event) {
      this.handleUpdate({
        active: event,
      });
    },
    handleUpdate(value, updateHandler = this.update) {
      this.updating = true;
      updateHandler(value)
          // .then(() => this.updateSuccessAlert(this.getModelName()))
          .then(() => {
            this.isEditing = false;
            return this.$toast("Perubahan berhasil disimpan", {
              type: "success",
              timeout: 10000,
            });
          })
          .catch((error) => this.failedAlert(error))
          .finally(() => {
            this.updating = false;
          });
    },
    update(value) {
      return this.$axios.put(`/manufactures/${this.$route.params.key}`, {
        ...value,
      });
    },
    updateSuccessAlert(something) {
      return Swal.fire({
        title: this.$t("Success") + "!",
        text: this.$t(`You've updated {something}`, {something}),
        type: "success",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    failedAlert() {
      return this.$toast("Perubahan gagal disimpan", {
        type: "error",
        icon: {
          iconClass: "mdi mdi-close-circle toast-icon text-danger",
        },
        timeout: 10000,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .preloader-component {
    background-color: #ffffff;
  }
}

.container-title {
  margin-top: 10px;
  font-family: Lato;
  font-size: 12px;
  font-weight: 800;
  line-height: 14px;
  letter-spacing: 0.05em;
  text-align: left;
  margin-bottom: 8px;
  text-transform: uppercase;
  font-family: "Lato";
  color: #6c7589;
}

.custom-group {
  margin-bottom: 30px;
}

.custom-label,
.custom-text {
  font-family: Lato;
  font-size: 14px;

  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
}

.custom-label,
.label {
  font-weight: 700;
  color: #161b4d;
  text-transform: capitalize;
  margin-bottom: 16px;
}

.custom-text,
.value {
  font-weight: 400;
  color: #6c7589;
}

.value:not(.no-colon)::before {
  content: ": ";
}

.section-title {
  background-color: #f9fafb;
  color: #161b4d;
  padding: 14px 21px;
  text-transform: uppercase;
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.05em;
  text-align: left;
  border: 1px solid #ececf2;
}

.section-title:first-of-type {
  border-top: none;
}

.section-body {
  padding: 14px 20px;

  .section-label,
  .section-value {
    font-family: Lato;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
  }

  .section-label {
    color: #161b4d;
    font-weight: 400;
  }

  .section-value {
    color: #161b4d;
    font-weight: 700;
    text-align: right;
  }

  .section-row {
    padding: 6px 0;
  }
}

.sale-item-thead {
  color: #161b4d;
  background-color: #f9fafb;
  text-transform: uppercase;
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.05em;
  text-align: left;
}

.sale-item-tbody {
  color: #161b4d;
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
}

::v-deep .page-content {
  background: #eef3f7;
}

$badge-background-primary: rgba(198, 239, 255, 0.3);
$badge-color-primary: #0084f3;
$badge-background-warning: #fff8e7;
$badge-color-warning: #ff9d0b;

.badge-container {
  &-base {
    background: $badge-background-primary;

    .stakeholder {
      color: #161b4d;
      font-weight: 700;
      font-size: 14px;
    }

    .name {
      font-weight: 700;
      font-size: 20px;
    }
  }

  &-primary {
    @extend .badge-container-base;

    .name {
      color: $badge-color-primary;
    }
  }

  &-warning {
    @extend .badge-container-base;
    background: $badge-background-warning;

    .name {
      color: $badge-color-warning;
    }
  }
}

::v-deep {
  .overflow-hidden {
    overflow: hidden !important;
  }

  table {
    thead {
      background: #f9fafb !important;
    }
  }

  .custom-switch {
    .custom-control-input:checked {
      background-color: #4cb244;
      border-color: #4cb244;
    }

    .custom-control-input:focus ~ .custom-control-label::before {
      border-color: #4cb244 !important;
      box-shadow: 0 0 0 0.2rem rgba(255, 47, 69, 0.25) !important;
    }

    .custom-control-input:checked ~ .custom-control-label::before {
      border-color: #4cb244 !important;
      background-color: #4cb244 !important;
    }

    .custom-control-input:active ~ .custom-control-label::before {
      background-color: #4cb244 !important;
      border-color: #4cb244 !important;
    }

    .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
      border-color: #4cb244 !important;
    }

    .custom-control-input-green:not(:disabled):active
    ~ .custom-control-label::before {
      background-color: #4cb244 !important;
      border-color: #4cb244 !important;
    }
  }
}

.section-label {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #0084f3;
}

.label-auditable {
  color: rgb(108, 117, 137);
  font-weight: 400;
}
</style>
